import { render, staticRenderFns } from "./ProducingPage.vue?vue&type=template&id=74cf5830&scoped=true&"
import script from "./ProducingPage.vue?vue&type=script&lang=js&"
export * from "./ProducingPage.vue?vue&type=script&lang=js&"
import style0 from "./ProducingPage.vue?vue&type=style&index=0&id=74cf5830&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74cf5830",
  null
  
)

export default component.exports